"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProductTargetedButton = exports.isCartActionButton = exports.isCartActionButtonType = exports.isProductTargetedButtonType = exports.DEFAULT_BUTTON_TEXT_BY_TYPE = exports.INLINE_CTA_ACTION = exports.LP_BUTTON_TYPE = exports.IMAGE_SLOT_KIND_VALUES = exports.ApiProductGridType = exports.DYNAMIC_GRID_EXCLUSION_TAG = exports.DEFAULT_PRODUCT_GRID_COUNT = exports.MAX_PRODUCT_GRID_COUNT = exports.MIN_PRODUCT_GRID_COUNT = exports.ApiProductGridLayout = exports.ApiProductSource = exports.HIGHLIGHTED_PRODUCT_HASH = exports.DEFAULT_INCLUDE_PDP_REVIEWS = exports.DEFAULT_INCLUDE_PDP_CONTENT = exports.DEFAULT_SPACER_SPACING_PX = exports.SPACER_SPACING_PX_VALUES = exports.ApiSectionType = exports.CARD_VP_DISPLAY_OMIT_KEYS = exports.CARD_VP_DISPLAY_FIELDS = exports.BlackCrowPageIds = exports.OnboardingStep = exports.InvitationStatus = void 0;
const storefrontParams_1 = require("./storefrontParams");
var InvitationStatus;
(function (InvitationStatus) {
    InvitationStatus["ACTIVE"] = "ACTIVE";
    InvitationStatus["PENDING"] = "PENDING";
    InvitationStatus["EXPIRED"] = "EXPIRED";
})(InvitationStatus || (exports.InvitationStatus = InvitationStatus = {}));
var OnboardingStep;
(function (OnboardingStep) {
    OnboardingStep["ACTIVATE_TRIAL"] = "activate-trial";
    OnboardingStep["BOOK_CALL"] = "book-call";
    OnboardingStep["CHECKOUT_COMPLETED"] = "checkout-completed";
    OnboardingStep["META_APP_INSTALL"] = "meta-app-install";
    OnboardingStep["META_APP_INSTALLED"] = "meta-app-installed";
    OnboardingStep["META_SETUP"] = "meta-setup";
    OnboardingStep["RESTART_SUBSCRIPTION"] = "restart-subscription";
    OnboardingStep["SHOPIFY_APP_INSTALL"] = "shopify-app-install";
})(OnboardingStep || (exports.OnboardingStep = OnboardingStep = {}));
var BlackCrowPageIds;
(function (BlackCrowPageIds) {
    BlackCrowPageIds["landingPage"] = "bcai.storefront.landing_page";
    BlackCrowPageIds["cartPage"] = "bcai.storefront.cart";
    BlackCrowPageIds["addToCartPage"] = "bcai.storefront.add_to_cart";
    BlackCrowPageIds["pdpPage"] = "bcai.storefront.pdp";
    BlackCrowPageIds["plpPage"] = "bcai.storefront.plp";
    BlackCrowPageIds["initiateCheckoutPage"] = "bcai.storefront.initiate_checkout";
})(BlackCrowPageIds || (exports.BlackCrowPageIds = BlackCrowPageIds = {}));
exports.CARD_VP_DISPLAY_FIELDS = [
    'carouselImages',
    'bodyBadges',
    'title',
    'reviews',
];
exports.CARD_VP_DISPLAY_OMIT_KEYS = [
    'bodyContent',
    'reviewAnalysis',
    'productOptionGuide',
    'carouselImagePerceptualHashes',
];
var ApiSectionType;
(function (ApiSectionType) {
    ApiSectionType["ACCORDION"] = "ACCORDION";
    ApiSectionType["HTML"] = "HTML";
    ApiSectionType["CAROUSEL"] = "CAROUSEL";
    ApiSectionType["VIDEO_CAROUSEL"] = "VIDEO_CAROUSEL";
    ApiSectionType["PLP"] = "PLP";
    ApiSectionType["PERSONALIZED_PLP"] = "PERSONALIZED_PLP";
    ApiSectionType["PRODUCT_CARD"] = "PRODUCT_CARD";
    ApiSectionType["REVIEWS_SUMMARY"] = "REVIEWS_SUMMARY";
    ApiSectionType["REVIEWS_SECTION"] = "REVIEWS_SECTION";
    ApiSectionType["HEADER_TEXT"] = "HEADER_TEXT";
    ApiSectionType["BODY_TEXT"] = "BODY_TEXT";
    ApiSectionType["UPSELL_BOX"] = "UPSELL_BOX";
    ApiSectionType["RICH_TEXT"] = "RICH_TEXT";
    ApiSectionType["INLINE_PDP"] = "INLINE_PDP";
    ApiSectionType["CTA_BUTTON"] = "CTA_BUTTON";
    ApiSectionType["AI_REVIEWS_SUMMARY"] = "AI_REVIEWS_SUMMARY";
    ApiSectionType["REVIEWS_CAROUSEL"] = "REVIEWS_CAROUSEL";
    ApiSectionType["REVIEWS_IMAGES"] = "REVIEWS_IMAGES";
    ApiSectionType["COLLECTIONS_SECTION"] = "COLLECTIONS_SECTION";
    ApiSectionType["SPACER"] = "SPACER";
})(ApiSectionType || (exports.ApiSectionType = ApiSectionType = {}));
exports.SPACER_SPACING_PX_VALUES = [
    6, 12, 18, 24, 30, 36, 42, 48, 54, 60,
];
exports.DEFAULT_SPACER_SPACING_PX = 12;
/**
 * An inline PDP shows the purchase module alone unless something deliberately
 * asks for the product's body content or its reviews: inlined mid-page either
 * one buries every section under it.
 */
exports.DEFAULT_INCLUDE_PDP_CONTENT = false;
exports.DEFAULT_INCLUDE_PDP_REVIEWS = false;
exports.HIGHLIGHTED_PRODUCT_HASH = 'HIGHLIGHTED_PRODUCT_HASH';
var ApiProductSource;
(function (ApiProductSource) {
    ApiProductSource["RECENTLY_VIEWED"] = "RECENTLY_VIEWED";
    ApiProductSource["ADDED_TO_CART"] = "ADDED_TO_CART";
    ApiProductSource["PURCHASED"] = "PURCHASED";
})(ApiProductSource || (exports.ApiProductSource = ApiProductSource = {}));
var ApiProductGridLayout;
(function (ApiProductGridLayout) {
    ApiProductGridLayout["GRID"] = "GRID";
    ApiProductGridLayout["HORIZONTAL_SCROLL"] = "HORIZONTAL_SCROLL";
})(ApiProductGridLayout || (exports.ApiProductGridLayout = ApiProductGridLayout = {}));
exports.MIN_PRODUCT_GRID_COUNT = 1;
exports.MAX_PRODUCT_GRID_COUNT = 500;
exports.DEFAULT_PRODUCT_GRID_COUNT = 8;
/**
 * Tag used to exclude products from all dynamic product grids
 * (Best Sellers, Recently Viewed, Personalized Product Grids).
 * Products with this tag in Shopify will not appear in these grids.
 */
exports.DYNAMIC_GRID_EXCLUSION_TAG = 'black_crow_do_not_show_in_dynamic_grids';
var ApiProductGridType;
(function (ApiProductGridType) {
    ApiProductGridType["BEST_SELLERS"] = "BEST_SELLERS";
    ApiProductGridType["OFTEN_BOUGHT_TOGETHER"] = "OFTEN_BOUGHT_TOGETHER";
    ApiProductGridType["RECENTLY_VIEWED"] = "RECENTLY_VIEWED";
    ApiProductGridType["SHOP_THE_COLLECTION"] = "SHOP_THE_COLLECTION";
})(ApiProductGridType || (exports.ApiProductGridType = ApiProductGridType = {}));
exports.IMAGE_SLOT_KIND_VALUES = [
    'PRODUCT_HERO',
    'LIFESTYLE',
    'TEXTURE_SWATCH',
    'INGREDIENT_CALLOUT',
    'BEFORE_AFTER',
    'APPLICATION',
    'FEATURE_GRAPHIC',
];
var LP_BUTTON_TYPE;
(function (LP_BUTTON_TYPE) {
    LP_BUTTON_TYPE["LINK"] = "LINK";
    LP_BUTTON_TYPE["PDP"] = "PDP";
    LP_BUTTON_TYPE["PLP"] = "PLP";
    LP_BUTTON_TYPE["NONE"] = "NONE";
    LP_BUTTON_TYPE["BUY_NOW"] = "BUY_NOW";
    LP_BUTTON_TYPE["ADD_TO_CART"] = "ADD_TO_CART";
    LP_BUTTON_TYPE["ADD_TO_CART_AND_BUY_NOW"] = "ADD_TO_CART_AND_BUY_NOW";
})(LP_BUTTON_TYPE || (exports.LP_BUTTON_TYPE = LP_BUTTON_TYPE = {}));
var INLINE_CTA_ACTION;
(function (INLINE_CTA_ACTION) {
    INLINE_CTA_ACTION["ADD_TO_CART"] = "ADD_TO_CART";
    INLINE_CTA_ACTION["BUY_NOW"] = "BUY_NOW";
})(INLINE_CTA_ACTION || (exports.INLINE_CTA_ACTION = INLINE_CTA_ACTION = {}));
exports.DEFAULT_BUTTON_TEXT_BY_TYPE = {
    [LP_BUTTON_TYPE.BUY_NOW]: 'Buy Now',
    [LP_BUTTON_TYPE.ADD_TO_CART]: 'Add to Cart',
    [LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW]: 'Add to Cart|Buy Now',
    [LP_BUTTON_TYPE.PDP]: 'View Product',
    [LP_BUTTON_TYPE.PLP]: 'Shop Products',
    [LP_BUTTON_TYPE.LINK]: 'Shop Products',
};
const isProductTargetedButtonType = (type) => type === LP_BUTTON_TYPE.PDP ||
    type === LP_BUTTON_TYPE.BUY_NOW ||
    type === LP_BUTTON_TYPE.ADD_TO_CART ||
    type === LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW;
exports.isProductTargetedButtonType = isProductTargetedButtonType;
const isCartActionButtonType = (type) => type === LP_BUTTON_TYPE.BUY_NOW ||
    type === LP_BUTTON_TYPE.ADD_TO_CART ||
    type === LP_BUTTON_TYPE.ADD_TO_CART_AND_BUY_NOW;
exports.isCartActionButtonType = isCartActionButtonType;
const isCartActionButton = (button) => !!button && (0, exports.isCartActionButtonType)(button.type);
exports.isCartActionButton = isCartActionButton;
const isProductTargetedButton = (button) => !!button && (0, exports.isProductTargetedButtonType)(button.type);
exports.isProductTargetedButton = isProductTargetedButton;
__exportStar(require("./api-types/brandBenefits"), exports);
__exportStar(require("./api-types/brandGuidelines"), exports);
__exportStar(require("./api-types/promotions"), exports);
__exportStar(require("./api-types/scheduledPromotion"), exports);
__exportStar(require("./api-types/customization"), exports);
__exportStar(require("./api-types/landingPageBannerBenefit"), exports);
__exportStar(require("./api-types/reviewsCarousel"), exports);
__exportStar(require("./api-types/virtualProduct"), exports);
__exportStar(require("./api-types/sellingPlans"), exports);
__exportStar(require("./api-types/brandChat"), exports);
__exportStar(require("./api-types/supportTickets"), exports);
